export default __webpack_public_path__ + "static/media/agenda_blanca.7b4dec4f.png";